import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from '.';

const PrivateRoute = ({
  component: Component,
  propsToComponent = {},
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} {...propsToComponent} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )
    }
  />
);

export default PrivateRoute;
